<script setup lang="ts">
/**
 * Badge / pill / status chip. Consolidates the ~6 ad-hoc pill systems (status badges, counters,
 * tags, "saved" labels…). Tone carries semantic color; `pill` toggles full-round vs rounded.
 */
interface Props {
  tone?: 'neutral' | 'brand' | 'info' | 'success' | 'warning' | 'danger'
  size?: 'sm' | 'md'
  pill?: boolean
}
const props = withDefaults(defineProps<Props>(), { tone: 'neutral', size: 'md', pill: true })

const toneClass: Record<NonNullable<Props['tone']>, string> = {
  neutral: 'bg-gray-100 text-gray-800',
  brand: 'bg-primary-100 text-primary-700',
  info: 'bg-blue-100 text-blue-800',
  success: 'bg-primary-100 text-primary-800',
  warning: 'bg-amber-100 text-amber-800',
  danger: 'bg-danger-100 text-danger-800',
}
const sizeClass: Record<NonNullable<Props['size']>, string> = {
  sm: 'px-1.5 py-0.5 text-[10px]',
  md: 'px-2 py-0.5 text-xs',
}
</script>

<template>
  <span
    class="inline-flex items-center gap-1 font-medium"
    :class="[
      toneClass[props.tone],
      sizeClass[props.size],
      props.pill ? 'rounded-full' : 'rounded-md',
    ]"
  >
    <slot />
  </span>
</template>
